import { useState } from 'react';

export default function Footer() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d6be42qat3fprlkfq450', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', phone: '', company: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div id="contatti" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid md:grid-cols-2 gap-16 mb-16">
          <div>
            <h2 className="text-4xl font-black text-white mb-6">
              Contattaci
            </h2>
            <p className="text-gray-300 text-lg mb-8 leading-relaxed">
              Compila il form per richiedere informazioni, preventivi o per
              diventare nostro partner commerciale
            </p>

            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-orange-500 rounded-xl flex-shrink-0">
                  <i className="ri-map-pin-line text-xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-bold text-lg mb-1">Sede Legale</h4>
                  <p className="text-gray-300">
                    Corso Giacomo Matteotti 10
                    <br />
                    84015 Nocera Superiore (SA)
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-orange-500 rounded-xl flex-shrink-0">
                  <i className="ri-phone-line text-xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-bold text-lg mb-1">Telefono</h4>
                  <p className="text-gray-300">
                    <a
                      href="tel:3508972608"
                      className="hover:text-orange-400 transition-colors"
                    >
                      350 897 2608
                    </a>
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-orange-500 rounded-xl flex-shrink-0">
                  <i className="ri-mail-line text-xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-bold text-lg mb-1">Email</h4>
                  <p className="text-gray-300">
                    <a
                      href="mailto:amm.worldart@gmail.com"
                      className="hover:text-orange-400 transition-colors"
                    >
                      amm.worldart@gmail.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-gray-800 rounded-3xl p-8">
            <form
              id="contact_form"
              onSubmit={handleSubmit}
              className="space-y-6"
              data-readdy-form
            >
              <div>
                <label htmlFor="name" className="block text-sm font-semibold mb-2">
                  Nome e Cognome *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-xl text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all"
                  placeholder="Il tuo nome completo"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-semibold mb-2">
                  Email *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-xl text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all"
                  placeholder="tua@email.com"
                />
              </div>

              <div>
                <label htmlFor="phone" className="block text-sm font-semibold mb-2">
                  Telefono
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-xl text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all"
                  placeholder="Il tuo numero di telefono"
                />
              </div>

              <div>
                <label htmlFor="company" className="block text-sm font-semibold mb-2">
                  Azienda
                </label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-xl text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all"
                  placeholder="Nome della tua azienda"
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-semibold mb-2">
                  Messaggio *
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  maxLength={500}
                  rows={4}
                  className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-xl text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all resize-none"
                  placeholder="Descrivi la tua richiesta (max 500 caratteri)"
                ></textarea>
                <p className="text-xs text-gray-400 mt-1">
                  {formData.message.length}/500 caratteri
                </p>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-orange-500 text-white px-8 py-4 rounded-xl font-bold hover:bg-orange-600 transition-all duration-300 whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed shadow-lg hover:shadow-xl"
              >
                {isSubmitting ? 'Invio in corso...' : 'Invia Richiesta'}
              </button>

              {submitStatus === 'success' && (
                <div className="bg-green-500/20 border border-green-500 text-green-400 px-4 py-3 rounded-xl">
                  Messaggio inviato con successo! Ti contatteremo presto.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-500/20 border border-red-500 text-red-400 px-4 py-3 rounded-xl">
                  Errore nell&apos;invio. Riprova più tardi.
                </div>
              )}
            </form>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-12">
          <div className="grid md:grid-cols-4 gap-8 mb-12">
            <div className="md:col-span-2">
              <img
                src="https://public.readdy.ai/ai/img_res/e151dd92-7f78-4b55-bdbc-778a4989cb3c.png"
                alt="Word Art S.r.l.s"
                className="h-12 w-auto object-contain mb-6"
              />
              <p className="text-gray-300 mb-6 leading-relaxed">
                Il tuo partner di fiducia per la distribuzione all&apos;ingrosso di
                prodotti tecnologici ed elettrodomestici. Qualità garantita, prezzi
                competitivi e servizio professionale.
              </p>
              <div className="flex space-x-4">
                <a
                  href="#"
                  className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full cursor-pointer hover:bg-orange-500 transition-colors"
                >
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
                <a
                  href="#"
                  className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full cursor-pointer hover:bg-orange-500 transition-colors"
                >
                  <i className="ri-linkedin-fill text-lg"></i>
                </a>
                <a
                  href="#"
                  className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full cursor-pointer hover:bg-orange-500 transition-colors"
                >
                  <i className="ri-instagram-line text-lg"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-4">Link Rapidi</h4>
              <ul className="space-y-3">
                <li>
                  <a
                    href="#home"
                    className="text-gray-300 hover:text-orange-400 transition-colors cursor-pointer"
                  >
                    Home
                  </a>
                </li>
                <li>
                  <a
                    href="#chi-siamo"
                    className="text-gray-300 hover:text-orange-400 transition-colors cursor-pointer"
                  >
                    Chi Siamo
                  </a>
                </li>
                <li>
                  <a
                    href="#servizi"
                    className="text-gray-300 hover:text-orange-400 transition-colors cursor-pointer"
                  >
                    Servizi
                  </a>
                </li>
                <li>
                  <a
                    href="#prodotti"
                    className="text-gray-300 hover:text-orange-400 transition-colors cursor-pointer"
                  >
                    Prodotti
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-4">Informazioni</h4>
              <div className="space-y-2 text-sm text-gray-300">
                <p>
                  <strong>Word Art S.r.l.s</strong>
                </p>
                <p>REA: SA-518387</p>
                <p>P.IVA: IT06372480654</p>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
            <p>© 2025 Word Art S.r.l.s. Tutti i diritti riservati.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
